<template>
<div class="bg-login">

  <!-- Container -->
  <div class="bg-login-main">
    <section class="container">
      <div class="row bg-login-inner">
        <div class="form-title">{{ $t('login.title') }}</div>
      </div>
      <div class="row bg-login-inner" v-show="(authuser && authuser.subscribed && authuser.subscription.trial) || expiredAt">
        <form class="login form">
          <div class="notification-box" v-html="$t('signup.signup.trial_messeage', { trial_date: expiredAt })"></div>
          <!-- /name -->
          <button type="button" class="button button-primary next" @click="next">
            <span>{{ $t('common.button.next') }}</span>
          </button>
        </form>
      </div>
    </section>
    
  </div>
  <div class="bg-login-bottom">
    <div class="container">
      <div class="row bg-login-inner">
        <div class="label-title">{{ $t('signup.signup.label_payment') }}</div>
        <button type="button" class="button button-default next" @click="purchaseOrCheck">
          <span>{{ $t('signup.signup.register_step3') }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api, countrieList} from "../../config";

  export default {
    data() {
      return {
        loading: false,
        resent: false,
        csrf: "",
        error: {
          displayname: '',
        },
        form: {
          displayname: ''
        },
        authuser: null,
        countries: countrieList,
        selectCountry: { val: 'JP', name: "Japan" }
      };
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      expiredAt() {
        if(this.authuser) {
          if(this.authuser.subscribed && this.authuser.subscription.trial) {
            if(this.authuser.subscription.trial_ends_at) {
              let expiredAt = new Date(this.authuser.subscription.trial_ends_at);
              return expiredAt.toLocaleString(this.selectCountry.val.toLowerCase())
            } else {
              return ''
            }
          } else {
            if(this.authuser.expired_at) {
              let expiredAt = new Date(this.authuser.expired_at);
              return expiredAt.toLocaleString(this.selectCountry.val.toLowerCase())
            } else {
              return ''
            }
          }
        } else {
          return ''
        }
      }
    },
    created() {
      const self = this
      
      self.$store.dispatch('selectLanguage', 'en')
      
      self.$store.dispatch("showLoading", true);
    
      axios.get(api.currentUser, {
        params: { type: 'signup'}
      })
      .then((resp) => {
        this.authuser = resp.data;
        self.$store.dispatch('setAuthUser', resp.data)
        self.$store.dispatch("showLoading", false);
      });
    },
    methods: {
      next() {
        this.$router.push({name: 'top'});
      },
      purchaseOrCheck() {
        if(this.authuser && this.authuser.subscribed && this.authuser.subscription.trial) {
          this.$router.push({name: 'profile.subscription'});
        } else {
          this.$router.push({name: 'apps.purchase'});
        }
      }
    }
  }
</script>
